// extracted by mini-css-extract-plugin
export default {"content":"Input_content__FBPtU","label":"Input_label__NXpCD","input":"Input_input__E5rzA","btn":"Input_btn__IBpxx","icon":"Input_icon__8yNY4"};